import { Modal } from 'antd';

export const LCModalInfo = Modal.info;
